import { createEvent } from 'effector'
import { InitialConfig } from '@loctypes/initial-config'
import { WidgetConfig } from '@loctypes'

export const customizeConfig = createEvent<InitialConfig['customizing']>()
export const setConfig = createEvent<WidgetConfig>()
